/**
 * Single source of truth for group/region labeling, shared between the
 * generators (which assign real labels at generation time) and the group
 * assignment editor UI (which needs to preview the same labels before
 * generation happens).
 */

export const REGION_NAMES = ['East', 'West', 'South', 'Midwest', 'Northeast', 'Southwest', 'Northwest', 'Southeast'];

// `customNames` is `config.groupNames` (see useScheduleBuilder.js) — an
// organizer-entered override keyed by group index, e.g. renaming "Group A"
// to a real club name for a Dual Meet ("Parsippany" vs "Livingston"). A
// blank/whitespace-only override falls back to the generated default rather
// than showing an empty label. Ports the same rename capability the legacy
// production scheduler already has (ScheduleTab.jsx's `groupNames` state,
// used for MLP's cross-group "Dual Match" structure) into this module — see
// this module's save-schedule-autoseed-plan.md for the earlier investigation
// confirming that was existing, shipped functionality worth reusing the
// concept from, not a new idea.
export const getGroupLabel = (formatId, idx, customNames) => {
  const custom = customNames?.[idx]?.trim();
  if (custom) return custom;
  if (formatId === 'regional_bracket') return REGION_NAMES[idx] || `Region ${idx + 1}`;
  return `Group ${String.fromCharCode(65 + idx)}`;
};
